import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=7fe9dc6b&scoped=true&"
import script from "./NewsInformation.vue?vue&type=script&lang=js&"
export * from "./NewsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9dc6b",
  null
  
)

export default component.exports